import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getWorkoutTemplates, deleteWorkoutTemplate } from '../api';

const WorkoutTemplateList = () => {
    const [templates, setTemplates] = useState([]);

    useEffect(() => {
        fetchTemplates();
    }, []);

    const fetchTemplates = async () => {
        try {
            const response = await getWorkoutTemplates();
            setTemplates(response.data);
        } catch (error) {
            console.error('Failed to fetch workout templates', error);
        }
    };

    
    const deleteTemplate = async (templateId) => {
        if (window.confirm('Are you sure you want to delete this template?')) {
            try {
                await deleteWorkoutTemplate(templateId);
                fetchTemplates();
                alert('Template deleted successfully!');
            } catch (error) {
                console.error('Failed to delete workout template', error);
                alert('Failed to delete workout template.');
            }
        }
    };
    

    return (
        <div className="container mx-auto p-4">
            <div className="flex justify-between items-center mb-4">
                <h1 className="text-2xl font-bold">Workout Templates</h1>
                <Link to="/workout-template-builder" className="btn btn-primary btn-sm me-2">
                    Create New Template
                </Link>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {templates.map(template => (
                    <div key={template.template_id} className="p-4 border rounded shadow">
                        <h2 className="text-xl font-semibold">{template.template_name}</h2>
                        <p className="text-gray-600">{template.description}</p>
                        <div className="mt-2">
                            <p><strong>Difficulty:</strong> {template.difficulty_level}</p>
                            <p><strong>Duration:</strong> {template.duration_weeks} weeks</p>
                        </div>
                        <div className="flex justify-end mt-4 gap-2">
                            <Link to={`/workout-template-builder/${template.template_id}`} className="btn btn-primary btn-sm me-2">
                                Edit
                            </Link>
                            <button onClick={() => deleteTemplate(template.template_id)} className="btn btn-danger btn-sm">
                                Delete
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default WorkoutTemplateList;